'use strict';

angular.module('study.ecrd.field.queries')
    .controller('FieldCreateQueryController', ['$scope', 'CrdConfigurationService', function($scope, CrdConfigurationService) {
        var vm = this;

        vm.newNote = {};

        vm.messages = CrdConfigurationService.getQueries().getFixedMessages().create;
        vm.hasPresetMessages = vm.messages && vm.messages.length > 0;

        vm.fixedMessage = null;

        vm.allowManualInput = false;
        vm.requireManualInput = false;

        // Control de error para incluir el mensaje teniendo en cuenta las opciones predefinidas si hay
        vm.error = {};

        vm.createNote = function() {
            if (vm.fixedMessage) {
                if (vm.newNote.text) {
                    vm.newNote.text = [vm.fixedMessage.message, vm.newNote.text].join('\n');
                } else {
                    vm.newNote.text = vm.fixedMessage.message;
                }
            }

            $scope.closeThisDialog(vm.newNote); // eslint-disable-line angular/controller-as
        };

        vm.closeModal = function() {
            $scope.dismissThisDialog('entity-note-creation-cancelled'); // eslint-disable-line angular/controller-as
        };

        vm.setFixedMessage = function() {
            if (vm.fixedMessage) {
                vm.allowManualInput = vm.fixedMessage.manual !== 'forbid';
                vm.requireManualInput = vm.fixedMessage.manual === 'require';
            } else {
                // Si hay mensajes prefijados significa que no se ha elegido ninguno, primero hay que elegir uno válido
                // Si no hay mensajes predefinidos, entonces la introducción manual es siempre obligatoria
                vm.allowManualInput = !vm.hasPresetMessages;
                vm.requireManualInput = !vm.hasPresetMessages;
            }

            if (!vm.allowManualInput && vm.manualReason) {
                // Actualizar mensaje manual vacío si no se requiere
                vm.newNote.text = '';
            }
        };

        // Inicialización de las variables de control
        vm.setFixedMessage();
    }]);
